const et = {
  // ============================================================
  // COMMON — Jagatud kogu rakenduses
  // ============================================================
  common: {
    loading: 'Laadimine...',
    error: 'Viga',
    save: 'Salvesta',
    cancel: 'Tühista',
    delete: 'Kustuta',
    edit: 'Muuda',
    create: 'Loo',
    add: 'Lisa',
    remove: 'Eemalda',
    close: 'Sulge',
    confirm: 'Kinnita',
    apply: 'Rakenda',
    reset: 'Lähtesta',
    search: 'Otsi',
    filter: 'Filtreeri',
    clear: 'Tühjenda',
    back: 'Tagasi',
    next: 'Järgmine',
    previous: 'Eelmine',
    submit: 'Esita',
    update: 'Uuenda',
    refresh: 'Värskenda',
    export: 'Ekspordi',
    import: 'Impordi',
    download: 'Laadi alla',
    upload: 'Laadi üles',
    print: 'Prindi',
    copy: 'Kopeeri',
    yes: 'Jah',
    no: 'Ei',
    ok: 'OK',
    done: 'Valmis',
    select: 'Vali',
    selectAll: 'Vali kõik',
    deselectAll: 'Tühista valik',
    noResults: 'Tulemusi ei leitud',
    noData: 'Andmed puuduvad',
    required: 'Kohustuslik',
    optional: 'Valikuline',
    actions: 'Tegevused',
    details: 'Üksikasjad',
    overview: 'Ülevaade',
    summary: 'Kokkuvõte',
    total: 'Kokku',
    all: 'Kõik',
    none: 'Puudub',
    name: 'Nimi',
    type: 'Tüüp',
    status: 'Staatus',
    date: 'Kuupäev',
    time: 'Aeg',
    description: 'Kirjeldus',
    notes: 'Märkused',
    comments: 'Kommentaarid',
    category: 'Kategooria',
    priority: 'Prioriteet',
    nation: 'Riik',
    country: 'Riik',
    email: 'E-post',
    phone: 'Telefon',
    address: 'Aadress',
    location: 'Asukoht',
    coordinates: 'Koordinaadid',
    latitude: 'Laiuskraad',
    longitude: 'Pikkuskraad',
    from: 'Kellelt',
    to: 'Kellele',
    createdAt: 'Loodud',
    updatedAt: 'Uuendatud',
    createdBy: 'Loonud',
    modifiedBy: 'Muutnud',
    active: 'Aktiivne',
    inactive: 'Mitteaktiivne',
    enabled: 'Lubatud',
    disabled: 'Keelatud',
    showing: 'Näidatakse',
    of: '/',
    page: 'Lehekülg',
    perPage: 'lehel',
    rows: 'rida',
    items: 'kirjet',
    results: 'tulemust',
    sortBy: 'Sorteeri',
    ascending: 'Kasvav',
    descending: 'Kahanev',
    viewAll: 'Vaata kõiki',
    viewDetails: 'Vaata üksikasju',
    goBack: 'Mine tagasi',
    learnMore: 'Loe lähemalt',
    seeMore: 'Vaata veel',
    showMore: 'Näita rohkem',
    showLess: 'Näita vähem',
    expandAll: 'Laienda kõik',
    collapseAll: 'Ahenda kõik',
    copied: 'Kopeeritud!',
    saved: 'Salvestatud!',
    deleted: 'Kustutatud!',
    updated: 'Uuendatud!',
    created: 'Loodud!',
    success: 'Õnnestus',
    warning: 'Hoiatus',
    info: 'Teave',
    danger: 'Oht',
    unknown: 'Teadmata',
    notAvailable: 'Puudub',
    never: 'Mitte kunagi',
    today: 'Täna',
    yesterday: 'Eile',
    tomorrow: 'Homme',
    now: 'Praegu',
    ago: 'tagasi',
    justNow: 'just praegu',
    minutesAgo: '{{count}}m tagasi',
    hoursAgo: '{{count}}t tagasi',
    daysAgo: '{{count}}p tagasi',
    monthsAgo: '{{count}}k tagasi',
    id: 'ID',
    version: 'Versioon',
    language: 'Keel',
    theme: 'Teema',
    darkMode: 'Tume režiim',
    lightMode: 'Hele režiim',
    failedToLoad: 'Andmete laadimine ebaõnnestus',
    failedToSave: 'Salvestamine ebaõnnestus',
    failedToDelete: 'Kustutamine ebaõnnestus',
    failedToUpdate: 'Uuendamine ebaõnnestus',
    confirmDelete: 'Kas olete kindel, et soovite selle kustutada?',
    confirmAction: 'Kas olete kindel?',
    unsavedChanges: 'Teil on salvestamata muudatused. Kas olete kindel, et soovite lahkuda?',
    pageNotFound: '404 - Lehekülge ei leitud',
    pageNotFoundDesc: 'Otsitavat lehekülge ei ole olemas.',
    backToDashboard: 'Tagasi juhtpaneelile',
    characters: 'tähemärki',
    maxCharacters: 'Maksimaalselt {{max}} tähemärki',
    remaining: '{{count}} jäänud',
    selected: '{{count}} valitud',
    of_total: '{{count}} / {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Päis, külgriba, menüüd
  // ============================================================
  nav: {
    dashboard: 'Juhtpaneel',
    requests: 'Taotlused',
    transports: 'Transpordid',
    myPatients: 'Minu patsiendid',
    statistics: 'Statistika',
    flow: 'Voog',
    resources: 'Resources',
    exercise: 'Õppus',
    administration: 'Haldus',
    map: 'Kaart',
    info: 'Teave',
    users: 'Kasutajad',
    assets: 'Vahendid',
    hubs: 'Sõlmpunktid',
    treatmentFacilities: 'Raviasutused',
    patientImport: 'Patsientide import',
    assetTemplates: 'Vahendite mallid',
    dayTemplates: 'Päevamallid',
    announcementTicker: 'Teadete riba',
    exerciseStatistics: 'Õppuse statistika',
    settings: 'Seaded',
    auditLog: 'Auditilogi',
    exerciseControl: 'Õppuse juhtimine',
    dataSync: 'Andmete sünkroonimine',
    documentation: 'Dokumentatsioon',
    support: 'Tugi',
    about: 'Teave',
    assetContracts: 'Asset Contracts',
    notifications: 'Teavitused',
    schedules: 'Ajakavad',
    capacityPlanning: 'Mahutavuse planeerimine',
    transportPlanning: 'Transpordi planeerimine',
    transportBooking: 'Transpordi broneerimine',
    flowDiagram: 'Vooskeem',
    changePassword: 'Muuda parooli',
    missions: 'Missioonid',
    startPoints: 'Lähtepunktid',
    hospital: 'Haigla',
  },

  // ============================================================
  // AUTH — Sisselogimine, parool, sessioon
  // ============================================================
  auth: {
    login: 'Logi sisse',
    logout: 'Logi välja',
    logoutNow: 'Logi kohe välja',
    loggingIn: 'Sisselogimine...',
    loginFailed: 'Sisselogimine ebaõnnestus',
    email: 'E-post',
    password: 'Parool',
    username: 'Kasutajanimi',
    enterEmail: 'Sisestage oma e-posti aadress',
    enterPassword: 'Sisestage oma parool',
    enterUsername: 'Sisestage oma kasutajanimi',
    forgotPassword: 'Unustasid parooli?',
    forgotPasswordTitle: 'Unustatud parool',
    forgotPasswordDesc: 'Sisestage oma kasutajanimi ja e-posti aadress. Kui mõlemad kattuvad, teavitatakse administraatoreid teie parooli lähtestamiseks.',
    requestPasswordReset: 'Taotle parooli lähtestamist',
    sending: 'Saatmine...',
    backToLogin: 'Tagasi sisselogimisele',
    pleaseWait: 'Palun oodake enne uuesti proovimist.',
    requestFailed: 'Taotlus ebaõnnestus',
    credentialsMatch: 'Kui andmed kattuvad, on administraatoreid teavitatud.',
    forAccess: 'Ligipääsuks pöörduge oma süsteemiadministraatori poole.',
    changePassword: 'Muuda parooli',
    currentPassword: 'Praegune parool',
    newPassword: 'Uus parool',
    confirmPassword: 'Kinnita parool',
    passwordChanged: 'Parool on edukalt muudetud',
    passwordMismatch: 'Paroolid ei kattu',
    passwordTooShort: 'Parool peab olema vähemalt 8 tähemärki',
    changingPassword: 'Muutmine...',
    mustChangePassword: 'Peate enne jätkamist oma parooli muutma.',
    sessionExpiring: 'Sessioon aegub',
    sessionExpireText: 'Teie sessioon aegub <strong>{{time}}</strong> pärast. Palun salvestage oma töö ja logige jätkamiseks uuesti sisse.',
    dismiss: 'Sulge',
    switchNation: 'Vaheta riiki',
    returnTo: 'Tagasi riigile {{nation}}',
    viewingAs: 'Vaatate kui',
    loggedInAs: 'sisse logitud kui {{nation}}',
    trainingMode: 'AINULT KOOLITUSE EESMÄRGIL',
    dedication: 'Loodud armastuse ja pühendumisega elukutsele',
  },

  // ============================================================
  // ROLES — Kasutajarollid ja sildid
  // ============================================================
  roles: {
    admin: 'Süsteemiadministraator',
    excon: 'Õppuse juht',
    eu: 'EL-i koordinaator',
    planner: 'Planeerija',
    hub: 'Sõlmpunkti haldur',
    nation: 'Riik',
    readOnly: 'Ainult lugemine',
    systemAdmin: 'Süsteemiadministraator',
    transportPlanner: 'Transpordi planeerija',
    systemRoles: 'Süsteemirollid',
  },

  // ============================================================
  // STATUS — Taotluste, pakkumiste, missioonide staatused
  // ============================================================
  status: {
    draft: 'Mustand',
    underReview: 'Ülevaatamisel',
    published: 'Avaldatud',
    underSelection: 'Valiku all',
    accepted: 'Vastu võetud',
    planned: 'Planeeritud',
    inTransit: 'Teel',
    completed: 'Lõpetatud',
    closed: 'Suletud',
    withdrawn: 'Tagasi võetud',
    pending: 'Ootel',
    rejected: 'Tagasi lükatud',
    cancelled: 'Tühistatud',
    active: 'Aktiivne',
    inactive: 'Mitteaktiivne',
    review: 'Ülevaatus',
    selection: 'Valik',
    transit: 'Transiit',
  },

  // ============================================================
  // CATEGORIES — Taotluste kategooriad
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Materjal',
    equipment: 'Varustus',
    other: 'Muu',
    news: 'Uudised',
  },

  // ============================================================
  // URGENCY — Kiireloomulisuse tasemed
  // ============================================================
  urgency: {
    routine: 'Rutiinne',
    priority: 'Prioriteetne',
    urgent: 'Kiire',
    immediate: 'Viivitamatu',
  },

  // ============================================================
  // ASSETS — Transpordivahendite tüübid
  // ============================================================
  assetTypes: {
    train: 'Rong',
    ship: 'Laev',
    aircraft: 'Lennuk',
    bus: 'Buss',
    ambulance: 'Kiirabi',
    drone: 'Droon',
    helicopter: 'Helikopter',
    ferry: 'Praam',
    other: 'Muu',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Juhtpaneel',
    goodMorning: 'Tere hommikust',
    goodAfternoon: 'Tere päevast',
    goodEvening: 'Tere õhtust',
    lastLogin: 'Viimane sisselogimine',
    infrastructure: 'Taristu',
    transportAssets: 'Transpordivahendid',
    treatmentFacilities: 'Raviasutused',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Taotluste statistika',
    viewAllRequests: 'Vaata kõiki taotlusi',
    availableAssets: 'Saadaolevad vahendid',
    seated: 'Istekohad',
    lying: 'Lamamiskoht',
    intensive: 'Intensiivravi',
    notifications: 'Teavitused',
    markAllRead: 'Märgi kõik loetuks',
    noNotifications: 'Teavitusi pole',
    notifiedWhenActivity: 'Teid teavitatakse, kui ilmneb uus tegevus',
    viewDetailsBtn: 'Vaata üksikasju',
    nationUsers: 'Riikide kasutajad',
    user: 'Kasutaja',
    roles: 'Rollid',
    noUsersFound: 'Kasutajaid ei leitud',
    participatingNations: 'Osalevad riigid',
    exerciseDisclaimer: 'See süsteem on mõeldud ainult õppuste jaoks. Sisestage ainult simuleeritud õppuseandmeid. Töövood on kohandatud õppuse stsenaariumile ja võivad erineda tegelikest protseduuridest. IT-turvalisuse ja andmekaitse reeglid kehtivad täies ulatuses.',
    notConfigured: 'Seadistamata',
    requestCount: '{{count}} taotlus(t)',
    clickToView: 'Klõpsake vaatamiseks',
    systemAdministration: 'Süsteemihaldus',
    exerciseControlTitle: 'Õppuse juhtimine',
    euCoordination: 'EL-i koordineerimine',
    transportPlanningTitle: 'Transpordi planeerimine',
    hubManagement: 'Sõlmpunktide haldus',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Uus taotlus',
    myDrafts: 'Minu mustandid',
    pendingReview: 'Ülevaatamist ootavad',
    activeTransports: 'Aktiivsed transpordid',
    myPatients: 'Minu patsiendid',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Taotlused',
    newRequest: 'Uus taotlus',
    createRequest: 'Loo taotlus',
    editRequest: 'Muuda taotlust',
    requestDetail: 'Taotluse üksikasjad',
    requestId: 'Taotluse ID',
    fromNation: 'Riigilt',
    toNation: 'Riigile',
    requestingNation: 'Taotlev riik',
    receivingNation: 'Vastuvõttev riik',
    category: 'Kategooria',
    urgency: 'Kiireloomulisus',
    status: 'Staatus',
    patients: 'Patsiendid',
    patientCount: 'Patsientide arv',
    offers: 'Pakkumised',
    offerCount: 'Pakkumiste arv',
    created: 'Loodud',
    updated: 'Uuendatud',
    submittedBy: 'Esitanud',
    reviewedBy: 'Üle vaadanud',
    description: 'Kirjeldus',
    medicalDetails: 'Meditsiinilised üksikasjad',
    transportDetails: 'Transpordi üksikasjad',
    additionalInfo: 'Lisateave',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Väljumiskoht',
    arrivalPoint: 'Saabumiskoht',
    estimatedDeparture: 'Eeldatav väljumine',
    estimatedArrival: 'Eeldatav saabumine',
    submitForReview: 'Esita ülevaatamiseks',
    publish: 'Avalda',
    startSelection: 'Alusta valikut',
    acceptOffer: 'Võta pakkumine vastu',
    markInTransit: 'Märgi teele saadetud',
    markCompleted: 'Märgi lõpetatuks',
    closeRequest: 'Sulge taotlus',
    withdrawRequest: 'Võta taotlus tagasi',
    withdraw: 'Võta tagasi',
    revertToDraft: 'Taasta mustandiks',
    deleteRequest: 'Kustuta taotlus',
    duplicateRequest: 'Dubleeri taotlus',
    createFollowUp: 'Loo konsolideeritud taotlus',
    followUpRequest: 'Konsolideeritud taotlus',
    parentRequest: 'Algne taotlus',
    childRequests: 'Konsolideeritud taotlused',
    noRequests: 'Taotlusi ei leitud',
    noOffers: 'Pakkumisi pole',
    addPatient: 'Lisa patsient',
    removePatient: 'Eemalda patsient',
    patientDetails: 'Patsiendi üksikasjad',
    contactPerson: 'Kontaktisik',
    contactPhone: 'Kontakttelefon',
    contactEmail: 'Kontakti e-post',
    specialRequirements: 'Erinõuded',
    medicalEquipment: 'Meditsiiniseadmed',
    accompaniment: 'Saatja',
    timeline: 'Ajajoon',
    history: 'Ajalugu',
    addComment: 'Lisa kommentaar',
    writeComment: 'Kirjutage kommentaar...',
    postComment: 'Postita kommentaar',
    posting: 'Postitamine...',
    noComments: 'Kommentaare pole',
    coverageBar: 'Kaetus',
    covered: 'kaetud',
    uncovered: 'katmata',
    filterByStatus: 'Filtreeri staatuse järgi',
    filterByCategory: 'Filtreeri kategooria järgi',
    filterByNation: 'Filtreeri riigi järgi',
    searchRequests: 'Otsi taotlusi...',
    confirmWithdraw: 'Kas olete kindel, et soovite selle taotluse tagasi võtta?',
    confirmDelete: 'Kas olete kindel, et soovite selle taotluse kustutada?',
    confirmPublish: 'Kas olete kindel, et soovite selle taotluse avaldada? See muutub kõigile riikidele nähtavaks.',
    confirmStartSelection: 'Kas olete kindel, et soovite valikut alustada? Riigid saavad esitada pakkumisi.',
    warningStartSelection: 'Valiku alustamine teeb selle taotluse nähtavaks kõigile osalevatele riikidele. Nad saavad esitada pakkumisi selle taotluse patsientide kohta. Seda tegevust ei saa tagasi võtta.',
    warningMakeOffer: 'Selle pakkumise esitamisega kohustate oma riiki pakutavat abi osutama. See tegevus teavitab taotlevat riiki ja õppuse juhtkonda.',
    saveDraft: 'Salvesta mustand',
    saving: 'Salvestamine...',
    saveAndSubmit: 'Salvesta ja esita',
    step: 'Samm {{number}}',
    generalInfo: 'Üldteave',
    patientInfo: 'Patsienditeave',
    logisticsInfo: 'Logistikateave',
    reviewSubmit: 'Ülevaatus ja esitamine',
    requestTitle: 'Taotluse pealkiri',
    requestDescription: 'Taotluse kirjeldus',
    numberOfPatients: 'Patsientide arv',
    typeOfAssistance: 'Abi liik',
    medicalTreatment: 'Meditsiiniline ravi',
    transportAssistance: 'Transpordiabi',
    both: 'Mõlemad',
    treatmentOnly: 'Ainult ravi',
    transportOnly: 'Ainult transport',
    validationErrors: 'Palun parandage järgmised vead:',
    fieldRequired: 'See väli on kohustuslik',
    selectExitHub: 'Valige väljumissõlm',
    createExitHub: 'Loo väljumissõlm',
    backToRequests: 'Tagasi taotluste juurde',
    noRequestsFound: 'Taotlusi ei leitud',
    createFirstRequest: 'Alustamiseks looge oma esimene taotlus',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Pakkumised',
    createOffer: 'Loo pakkumine',
    makeOffer: 'Tee pakkumine',
    manageOffers: 'Halda pakkumisi',
    offerDetail: 'Pakkumise üksikasjad',
    offerId: 'Pakkumise ID',
    offeringNation: 'Pakkuv riik',
    offerType: 'Pakkumise tüüp',
    treatment: 'Ravi',
    transport: 'Transport',
    combined: 'Kombineeritud',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ravipakkumine',
    transportOffer: 'Transpordipakkumine',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Valige patsiendid',
    selectedPatients: 'Valitud patsiendid',
    patientSelection: 'Patsientide valik',
    offerConfiguration: 'Pakkumise seadistamine',
    reviewOffer: 'Pakkumise ülevaatus',
    submitOffer: 'Esita pakkumine',
    submitting: 'Esitamine...',
    acceptOffer: 'Võta pakkumine vastu',
    rejectOffer: 'Lükka pakkumine tagasi',
    withdrawOffer: 'Võta pakkumine tagasi',
    noOffers: 'Pakkumisi pole saadaval',
    noOffer: 'No Offer',
    offerStatus: 'Pakkumise staatus',
    offerDate: 'Pakkumise kuupäev',
    transportAsset: 'Transpordivahend',
    departureDate: 'Väljumiskuupäev',
    arrivalDate: 'Saabumiskuupäev',
    treatmentFacility: 'Raviasutus',
    capacity: 'Mahutavus',
    availableCapacity: 'Vaba mahutavus',
    totalCapacity: 'Kogumahutavus',
    selectAsset: 'Valige vahend',
    selectFacility: 'Valige asutus',
    offerNotes: 'Pakkumise märkused',
    confirmAccept: 'Kas olete kindel, et soovite selle pakkumise vastu võtta?',
    confirmReject: 'Kas olete kindel, et soovite selle pakkumise tagasi lükata?',
    extendTransport: 'Laiendatud transport',
    transportExtension: 'Transpordi laiendus',
    comparisonView: 'Võrdlusvaade',
    shortlist: 'Eelvalik',
    addToShortlist: 'Lisa eelvalikusse',
    removeFromShortlist: 'Eemalda eelvalikust',
    leaveConfirmTitle: 'Lahkuda lehelt?',
    leaveConfirmMessage: 'Teil on salvestamata muudatused. Kas olete kindel, et soovite lahkuda?',
    stayOnPage: 'Jää lehele',
    leavePage: 'Lahku lehelt',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transpordid',
    missionDetail: 'Transpordi üksikasjad',
    missionId: 'Transpordi ID',
    missionStatus: 'Transpordi staatus',
    createMission: 'Loo transport',
    overview: 'Ülevaade',
    patientsTab: 'Patsiendid',
    transportsTab: 'Transpordietapid',
    treatmentTab: 'Ravi',
    reviewTab: 'Ülevaatus',
    departure: 'Väljumine',
    arrival: 'Saabumine',
    origin: 'Lähtepunkt',
    destination: 'Sihtkoht',
    stops: 'Peatused',
    addStop: 'Lisa peatus',
    removeStop: 'Eemalda peatus',
    stopName: 'Peatuse nimi',
    stopType: 'Peatuse tüüp',
    estimatedTime: 'Eeldatav aeg',
    actualTime: 'Tegelik aeg',
    asset: 'Vahend',
    driver: 'Juht',
    crew: 'Meeskond',
    noMissions: 'Transporte ei leitud',
    completeMission: 'Lõpeta transport',
    cancelMission: 'Tühista transport',
    startTransport: 'Alusta transporti',
    missionChain: 'Transpordiahel',
    linkedMissions: 'Seotud transpordid',
    handover: 'Üleandmine',
    handoverPoint: 'Üleandmispunkt',
    pickupPoint: 'Pealekoht',
    dropoffPoint: 'Mahakoht',
    searchTransports: 'Otsi transporte...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patsiendid',
    myPatients: 'Minu patsiendid',
    patientId: 'Patsiendi ID',
    firstName: 'Eesnimi',
    lastName: 'Perekonnanimi',
    dateOfBirth: 'Sünnipäev',
    age: 'Vanus',
    gender: 'Sugu',
    male: 'Mees',
    female: 'Naine',
    other: 'Muu',
    nationality: 'Kodakondsus',
    diagnosis: 'Diagnoos',
    condition: 'Seisund',
    stable: 'Stabiilne',
    critical: 'Kriitiline',
    serious: 'Tõsine',
    treatmentNeeded: 'Vajalik ravi',
    allergies: 'Allergiad',
    medications: 'Ravimid',
    bloodType: 'Veregrupp',
    weight: 'Kaal (kg)',
    infectious: 'Nakkusohtlik',
    mentalHealth: 'Vaimne tervis',
    mobility: 'Liikuvus',
    ambulatory: 'Liikumisvõimeline',
    wheelchair: 'Ratastool',
    stretcher: 'Kanderaam',
    intensive: 'Intensiivravi',
    oxygenRequired: 'Hapnik vajalik',
    ventilator: 'Ventilaator',
    medicalEscort: 'Meditsiiniline saatja',
    noPatients: 'Patsiente ei leitud',
    patientDetails: 'Patsiendi üksikasjad',
    medicalHistory: 'Haiguslugu',
    travelDocuments: 'Reisidokumendid',
    passport: 'Pass',
    pseudonymizedId: 'Pseudonümiseeritud ID',
    sensitiveData: 'Tundlikud andmed',
    journey: 'Patsiendi teekond',
    assignedTo: 'Määratud',
    currentLocation: 'Praegune asukoht',
    importPatients: 'Impordi patsiendid',
    exportPatients: 'Ekspordi patsiendid',
    seated: 'Istekohad',
    lying: 'Lamamiskoht',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Kasutajad',
    createUser: 'Loo kasutaja',
    editUser: 'Muuda kasutajat',
    deleteUser: 'Kustuta kasutaja',
    username: 'Kasutajanimi',
    displayName: 'Kuvatav nimi',
    email: 'E-post',
    password: 'Parool',
    role: 'Roll',
    roles: 'Rollid',
    nation: 'Riik',
    active: 'Aktiivne',
    lastLogin: 'Viimane sisselogimine',
    createdAt: 'Loodud',
    isNation: 'Riik',
    isEU: 'EL',
    isAdmin: 'Administraator',
    isExcon: 'EXCON',
    isPlanner: 'Planeerija',
    isHub: 'Sõlmpunkt',
    isReadOnly: 'Ainult lugemine',
    noUsers: 'Kasutajaid ei leitud',
    confirmDelete: 'Kas olete kindel, et soovite selle kasutaja kustutada?',
    resetPassword: 'Lähtesta parool',
    generatePassword: 'Genereeri parool',
    searchUsers: 'Otsi kasutajaid...',
    userCreated: 'Kasutaja edukalt loodud',
    userUpdated: 'Kasutaja edukalt uuendatud',
    userDeleted: 'Kasutaja edukalt kustutatud',
    selectNation: 'Valige riik',
    mustChangePassword: 'Peab järgmisel sisselogimisel parooli muutma',
    flagImage: 'Lipu pilt',
    exportUsers: 'Ekspordi kasutajad',
    importUsers: 'Impordi kasutajad',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Vahendid',
    createAsset: 'Loo vahend',
    editAsset: 'Muuda vahendit',
    deleteAsset: 'Kustuta vahend',
    assetName: 'Vahendi nimi',
    assetType: 'Vahendi tüüp',
    capacitySeated: 'Mahutavus (istekohad)',
    capacityLying: 'Mahutavus (lamamiskoht)',
    capacityIntensive: 'Mahutavus (intensiivravi)',
    owner: 'Omanik',
    operator: 'Operaator',
    baseLocation: 'Kodubaas',
    range: 'Ulatus',
    speed: 'Kiirus',
    noAssets: 'Vahendeid ei leitud',
    confirmDelete: 'Kas olete kindel, et soovite selle vahendi kustutada?',
    searchAssets: 'Otsi vahendeid...',
    assetCreated: 'Vahend edukalt loodud',
    assetUpdated: 'Vahend edukalt uuendatud',
    assetDeleted: 'Vahend edukalt kustutatud',
    exportAssets: 'Ekspordi vahendid',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Sõlmpunktid',
    startPoints: 'Lähtepunktid',
    createHub: 'Loo sõlmpunkt',
    editHub: 'Muuda sõlmpunkti',
    deleteHub: 'Kustuta sõlmpunkt',
    hubName: 'Sõlmpunkti nimi',
    hubType: 'Sõlmpunkti tüüp',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Sissetulemissõlm',
    airport: 'Lennujaam',
    seaport: 'Sadam',
    railStation: 'Raudteejaam',
    roadPoint: 'Maanteepunkt',
    ucpmClassification: 'UCPM klassifikatsioon',
    icaoCode: 'ICAO kood',
    iataCode: 'IATA kood',
    noHubs: 'Sõlmpunkte ei leitud',
    confirmDelete: 'Kas olete kindel, et soovite selle sõlmpunkti kustutada?',
    searchHubs: 'Otsi sõlmpunkte...',
    nationAssignment: 'Riikide määramine',
    assignNations: 'Määra riigid',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Raviasutused',
    createFacility: 'Loo asutus',
    editFacility: 'Muuda asutust',
    deleteFacility: 'Kustuta asutus',
    facilityName: 'Asutuse nimi',
    facilityType: 'Asutuse tüüp',
    hospitalName: 'Haigla nimi',
    bedCapacity: 'Voodikohtade arv',
    specialties: 'Erialad',
    availableBeds: 'Vabad voodikohad',
    totalBeds: 'Voodikohti kokku',
    contactPerson: 'Kontaktisik',
    noFacilities: 'Raviasutusi ei leitud',
    confirmDelete: 'Kas olete kindel, et soovite selle asutuse kustutada?',
    searchFacilities: 'Otsi asutusi...',
    hubNationAssignment: 'Sõlmpunkti riikide määramine',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Ajakavad',
    createSchedule: 'Loo ajakava',
    editSchedule: 'Muuda ajakava',
    deleteSchedule: 'Kustuta ajakava',
    scheduleName: 'Ajakava nimi',
    scheduleType: 'Ajakava tüüp',
    recurring: 'Korduv',
    oneTime: 'Ühekordne',
    frequency: 'Sagedus',
    daily: 'Igapäevane',
    weekly: 'Iganädalane',
    startDate: 'Alguskuupäev',
    endDate: 'Lõppkuupäev',
    departureTime: 'Väljumisaeg',
    arrivalTime: 'Saabumisaeg',
    stops: 'Peatused',
    addStop: 'Lisa peatus',
    noSchedules: 'Ajakavasid ei leitud',
    bookings: 'Broneeringud',
    timeline: 'Ajajoon',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Teavitused',
    markAllRead: 'Märgi kõik loetuks',
    markAsRead: 'Märgi loetuks',
    markAsUnread: 'Märgi lugemata',
    noNotifications: 'Teavitusi pole',
    viewAll: 'Vaata kõiki teavitusi',
    settings: 'Teavituste seaded',
    emailNotifications: 'E-posti teavitused',
    inAppNotifications: 'Rakendusesisesed teavitused',
    notifyOn: 'Teavita mind',
    requestCreated: 'Uus taotlus',
    requestPublished: 'Taotlus avaldatud',
    requestClosed: 'Taotlus suletud',
    requestCompleted: 'Taotlus lõpetatud',
    commentAdded: 'Uus kommentaar',
    offerReceived: 'Pakkumine saadud',
    offerAccepted: 'Pakkumine vastu võetud',
    statusChanged: 'Staatus muutunud',
    selectionStarted: 'Valik alanud',
    missionCreated: 'Transport loodud',
    missionStatusUpdated: 'Transport uuendatud',
    transportPartnerNamed: 'Transpordipartner',
    transportExtensionReceived: 'Transpordi laiendus',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Seaded',
    general: 'Üldine',
    system: 'Süsteem',
    email: 'E-post',
    sync: 'Sünkroonimine',
    security: 'Turvalisus',
    appearance: 'Välimus',
    systemName: 'Süsteemi nimi',
    systemEmail: 'Süsteemi e-post',
    maintenanceMode: 'Hooldusrežiim',
    readOnlyMode: 'Ainult lugemise režiim',
    emailEnabled: 'E-post lubatud',
    smtpHost: 'SMTP server',
    smtpPort: 'SMTP port',
    smtpUser: 'SMTP kasutaja',
    smtpPassword: 'SMTP parool',
    senderEmail: 'Saatja e-post',
    senderName: 'Saatja nimi',
    testEmail: 'Saada test-e-kiri',
    syncEnabled: 'Sünkroonimine lubatud',
    syncUrl: 'Sünkroonimise URL',
    syncApiKey: 'Sünkroonimise API võti',
    settingsSaved: 'Seaded edukalt salvestatud',
    helpdesk: 'Kasutajatugi',
    helpdeskTitle: 'Kasutajatoe pealkiri',
    helpdeskEmail: 'Kasutajatoe e-post',
    helpdeskPhone: 'Kasutajatoe telefon',
    helpdeskInfo: 'Kasutajatoe teave',
    realLifeSupport: 'Tegeliku elu tugi',
    trainingMode: 'Koolitusrežiim',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Auditilogi',
    action: 'Tegevus',
    user: 'Kasutaja',
    target: 'Sihtmärk',
    details: 'Üksikasjad',
    timestamp: 'Ajatempel',
    ipAddress: 'IP-aadress',
    noLogs: 'Auditilogisid ei leitud',
    searchLogs: 'Otsi logisid...',
    filterByAction: 'Filtreeri tegevuse järgi',
    filterByUser: 'Filtreeri kasutaja järgi',
    exportLogs: 'Ekspordi logid',
    exportCsv: 'Ekspordi CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Õppuse juhtimine',
    currentDay: 'Praegune päev',
    exerciseDay: 'Õppuse päev',
    nextDay: 'Järgmine päev',
    previousDay: 'Eelmine päev',
    resetExercise: 'Lähtesta õppus',
    startExercise: 'Alusta õppust',
    endExercise: 'Lõpeta õppus',
    dayReset: 'Päeva lähtestamine',
    confirmReset: 'Kas olete kindel, et soovite õppuse päeva lähtestada? See kustutab kõik praeguse päeva andmed.',
    resetInProgress: 'Lähtestamine käib...',
    maintenanceMode: 'Hooldusrežiim',
    enableMaintenance: 'Luba hooldus',
    disableMaintenance: 'Keela hooldus',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Andmete sünkroonimine',
    syncStatus: 'Sünkroonimise staatus',
    lastSync: 'Viimane sünkroonimine',
    pendingItems: 'Ootel kirjed',
    syncNow: 'Sünkrooni kohe',
    syncing: 'Sünkroonimine...',
    syncSuccess: 'Sünkroonimine edukalt lõpetatud',
    syncFailed: 'Sünkroonimine ebaõnnestus',
    outbox: 'Väljuvad',
    inbox: 'Sissetulevad',
    configuration: 'Seadistamine',
    targetUrl: 'Siht-URL',
    apiKey: 'API võti',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kaart',
    layers: 'Kihid',
    requests: 'Taotlused',
    hubs: 'Sõlmpunktid',
    facilities: 'Asutused',
    routes: 'Marsruudid',
    showAll: 'Näita kõiki',
    hideAll: 'Peida kõik',
    zoomIn: 'Suurenda',
    zoomOut: 'Vähenda',
    resetView: 'Lähtesta vaade',
    satellite: 'Satelliit',
    terrain: 'Maastik',
    offline: 'Võrguta',
    online: 'Võrgus',
    tilesOffline: 'Kaardipaanid laetakse lokaalselt',
    tilesOnline: 'Kaardipaanid laetakse veebiserveritelt',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Ülevaade',
    requestsByStatus: 'Taotlused staatuse järgi',
    requestsByCategory: 'Taotlused kategooria järgi',
    requestsByNation: 'Taotlused riigi järgi',
    offersByStatus: 'Pakkumised staatuse järgi',
    patientsByCondition: 'Patsiendid seisundi järgi',
    transportsByStatus: 'Transpordid staatuse järgi',
    timeline: 'Ajajoon',
    totalRequests: 'Taotlusi kokku',
    totalOffers: 'Pakkumisi kokku',
    totalPatients: 'Patsiente kokku',
    totalTransports: 'Transporte kokku',
    averageResponseTime: 'Keskmine reageerimisaeg',
    completionRate: 'Lõpetamise määr',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Õppuse statistika',
    overview: 'Ülevaade',
    byCategory: 'Kategooria järgi',
    byNation: 'Riigi järgi',
    byDay: 'Päeva järgi',
    totalPatientsMoved: 'Transporditud patsiente kokku',
    totalRequestsProcessed: 'Töödeldud taotlusi kokku',
    averageProcessingTime: 'Keskmine töötlemisaeg',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Vooskeem',
    sankey: 'Sankey',
    nodeGraph: 'Sõlmgraafik',
    refresh: 'Värskenda',
    noData: 'Vooandmed puuduvad',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Teave',
    version: 'Versioon',
    systemInfo: 'Süsteemiteave',
    buildDate: 'Ehituse kuupäev',
    environment: 'Keskkond',
    description: 'ARCOS — Täiustatud taotluste kommunikatsioonisüsteem',
    subtitle: 'Kannatanute abi ja meditsiinioperatsioonid',
    whatIsArcos: 'Mis on ARCOS? – Selgitus õppuse osalejatele',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Toetab MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – kus uudishimu kohtub koostööga.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentatsioon',
    gettingStarted: 'Alustamine',
    userGuide: 'Kasutusjuhend',
    faq: 'Korduma kippuvad küsimused',
    troubleshooting: 'Veaotsing',
    apiReference: 'API viide',
    downloadTemplate: 'Laadi mall alla',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patsientide import',
    uploadFile: 'Laadi fail üles',
    selectFile: 'Vali fail',
    preview: 'Eelvaade',
    importNow: 'Impordi kohe',
    importing: 'Importimine...',
    importSuccess: '{{count}} patsienti edukalt imporditud',
    importFailed: 'Import ebaõnnestus',
    downloadTemplate: 'Laadi mall alla',
    dragDrop: 'Lohistage fail siia või klõpsake valimiseks',
    supportedFormats: 'Toetatud vormingud: XLSX, XLS, CSV',
    rowsFound: '{{count}} rida leitud',
    validRows: '{{count}} kehtivat rida',
    invalidRows: '{{count}} kehtetut rida',
    duplicateRows: '{{count}} duplikaati',
    previewData: 'Andmete eelvaade',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transpordi planeerimine',
    planRoute: 'Planeeri marsruut',
    routeBuilder: 'Marsruudi koostaja',
    addWaypoint: 'Lisa vahepunkt',
    removeWaypoint: 'Eemalda vahepunkt',
    estimatedDuration: 'Eeldatav kestus',
    distance: 'Vahemaa',
    selectVehicle: 'Valige sõiduk',
  },

  transportBooking: {
    title: 'Transpordi broneerimine',
    bookTransport: 'Broneeri transport',
    availableSlots: 'Vabad kohad',
    bookingConfirmed: 'Broneering kinnitatud',
    cancelBooking: 'Tühista broneering',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Mahutavuse planeerimine',
    totalCapacity: 'Kogumahutavus',
    usedCapacity: 'Kasutatud mahutavus',
    availableCapacity: 'Vaba mahutavus',
    utilizationRate: 'Kasutusmäär',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Vahendite mallid',
    dayTemplates: 'Päevamallid',
    createTemplate: 'Loo mall',
    editTemplate: 'Muuda malli',
    deleteTemplate: 'Kustuta mall',
    templateName: 'Malli nimi',
    applyTemplate: 'Rakenda mall',
    noTemplates: 'Malle ei leitud',
    confirmDelete: 'Kas olete kindel, et soovite selle malli kustutada?',
    confirmApply: 'Kas olete kindel, et soovite seda malli rakendada? See kirjutab olemasolevad andmed üle.',
    exportTemplates: 'Ekspordi mallid',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Teadete riba',
    createAnnouncement: 'Loo teade',
    editAnnouncement: 'Muuda teadet',
    deleteAnnouncement: 'Kustuta teade',
    message: 'Sõnum',
    startTime: 'Algusaeg',
    endTime: 'Lõppaeg',
    active: 'Aktiivne',
    noAnnouncements: 'Teateid pole',
    confirmDelete: 'Kas olete kindel, et soovite selle teate kustutada?',
  },

  // ============================================================
  // COMPONENTS — Korduvkasutatavate komponentide stringid
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Otsi...',
      noResults: 'Tulemusi ei leitud',
      showing: 'Näidatakse {{from}} kuni {{to}} / {{total}}',
      rowsPerPage: 'Ridu lehel',
      previousPage: 'Eelmine lehekülg',
      nextPage: 'Järgmine lehekülg',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Kinnita',
      cancel: 'Tühista',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Salvestamata muudatused',
      message: 'Teil on salvestamata muudatused. Kas olete kindel, et soovite sellelt lehelt lahkuda?',
      stay: 'Jää lehele',
      leave: 'Lahku lehelt',
    },
    // EmptyState
    emptyState: {
      noData: 'Andmed puuduvad',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Midagi läks valesti',
      message: 'Ilmnes ootamatu viga. Palun proovige lehekülge värskendada.',
      retry: 'Proovi uuesti',
    },
    // ExportButton
    exportButton: {
      export: 'Ekspordi',
      exporting: 'Eksportimine...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Prindi',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Mustand',
      review: 'Ülevaatus',
      published: 'Avaldatud',
      selection: 'Valik',
      inTransit: 'Teel',
      completed: 'Lõpetatud',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Veebiversioon',
      message: 'Ainult lugemise režiim. Andmed sünkroonitakse peamise serveriga.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Vaatate kui',
      loggedInAs: 'sisse logitud kui {{nation}}',
      returnTo: 'Tagasi riigile {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Otsi lehekülgi, taotlusi, transporte...',
      searching: 'Otsimine...',
      noResults: 'Tulemusi päringule "{{query}}" ei leitud',
      navigate: 'Navigeeri',
      select: 'Vali',
      close: 'Sulge',
      pages: {
        dashboard: 'Juhtpaneel',
        requests: 'Taotlused',
        transports: 'Transpordid',
        map: 'Kaart',
        myPatients: 'Minu patsiendid',
        flowDiagram: 'Vooskeem',
        statistics: 'Statistika',
        assets: 'Vahendid',
        startPoints: 'Lähtepunktid / Sõlmpunktid',
        treatmentFacilities: 'Raviasutused',
        users: 'Kasutajad',
        settings: 'Seaded',
        auditLogs: 'Auditilogi',
        exerciseControl: 'Õppuse juhtimine',
        dataSync: 'Andmete sünkroonimine',
        patientImport: 'Patsientide import',
        notifications: 'Teavitused',
        documentation: 'Dokumentatsioon',
      },
      actions: {
        importPatientsJson: 'Impordi Patsiente (JSON)',
        importPatientsExcel: 'Impordi Patsiente (Excel)',
        importUsers: 'Impordi Kasutajaid (Excel)',
        importAssetTemplates: 'Impordi Vara malle (Excel)',
        importDayTemplates: 'Impordi Päevamalli kirjeid (Excel)',
        exportRequests: 'Ekspordi Taotlusi (Excel)',
        exportPatients: 'Ekspordi Patsiente (Excel)',
        exportUsers: 'Ekspordi Kasutajaid (Excel)',
        exportCredentials: 'Ekspordi Mandaadid (PDF)',
        exportAuditExcel: 'Ekspordi Auditi logi (Excel)',
        exportAuditPdf: 'Ekspordi Auditi logi (PDF)',
        pagePatientImport: 'Patsientide impordi leht',
        pageRequestDetail: 'Taotluse üksikasjade leht',
        pageUsers: 'Kasutajate halduse leht',
        pageAssetTemplates: 'Vara mallide leht',
        pageDayTemplates: 'Päevamallide leht',
        pageRequests: 'Taotluste loendi leht',
        pageAuditLogs: 'Auditi logi leht',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sessioon aegub',
      message: 'Teie sessioon aegub <strong>{{time}}</strong> pärast. Palun salvestage oma töö ja logige jätkamiseks uuesti sisse.',
      dismiss: 'Sulge',
      logoutNow: 'Logi kohe välja',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Valige 4 ajavööndit',
      configure: 'Seadistage ajavööndid',
      reset: 'Lähtesta',
      apply: 'Rakenda',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Valige asukoht',
      latitude: 'Laiuskraad',
      longitude: 'Pikkuskraad',
      clickToSelect: 'Klõpsake kaardil asukoha valimiseks',
    },
    // Modal
    modal: {
      close: 'Sulge',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Avaleht',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Süsteemi hooldus',
    message: 'Süsteemi lähtestatakse järgmise õppuse päeva jaoks. Palun oodake, kuni protsess on lõppenud.',
    autoRefresh: 'See lehekülg värskendatakse automaatselt, kui süsteem on taas kättesaadav.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Vähemalt 10 tähemärki',
    uppercase: '1 suurtäht',
    lowercase: '1 väiketäht',
    digit: '1 number',
    special: '1 erimärk',
  },
};

export default et;
